import React, { useState, useRef } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'

const Agree = ({ setAc, setTk, ac, tk, pid, setIsLoading }) => {
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  // 需要登入嗎
  const requiresLogin = {
    login: false,
    title: '驗證碼',
    placeholder: '請輸入驗證碼',
    alert: '請填寫您的手機或信箱',
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(3)
  // }, [])
  const completedHtml = `<h3>問卷已成功送出，感謝您的參與</h3><h4>如有填卷相關問題請洽：</h4> <a href='https://lin.ee/HWETcqy'>https://lin.ee/HWETcqy</a><h4 style='margin-top:50px'>填寫其他問卷：</h4> <a href=${window.location.origin}>${window.location.origin}</a>`

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列

  // const visibleIfConditionsInit = {
  //   q6: '{q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3',
  //   q7: '{q6} = ["none"]',
  //   q36: `{q35} <> ['none']`,
  // }

  // const visibleIfConditionsInit = {
  //   q5: '{q4} = 0',
  //   q6: '{q4} = 1',
  //   q7: '{q4} = 2',
  //   q8: '{q4} = 3',
  //   q9: '{q4} = 4',
  //   q10: '{q4} = 5',
  //   q11: '{q4} = 6',
  //   q12: '{q4} = 7',
  //   q13: '{q4} = 8',
  //   q14: '{q4} = 9',
  //   q15: '{q4} = 10',
  //   q16: '{q4} = 11',
  //   q17: '{q4} = 12',
  //   q18: '{q4} = 13',
  //   q19: '{q4} = 14',
  //   q20: '{q4} = 15',
  //   q21: '{q4} = 16',
  //   q22: '{q4} = 17',
  //   q23: '{q4} = 18',
  //   q24: '{q4} = 19',
  //   q25: '{q4} = 20',
  //   q26: '{q4} = 21',
  //   q31: '{q30} = 1',
  //   q33: '{q32} = 1',
  //   q35: '{q34} = 1',
  //   q45: '{q44} = 0 or {q44} = 1',
  //   q47: '{q46} = 1 or {q46} = 2',
  //   q49: '{q48} = 1 or {q48} = 2 or {q48} = 3 or {q48} = 4',
  //   q50: '{q48} = 1 or {q48} = 2 or {q48} = 3 or {q48} = 4',
  //   q53: '{q52} = 1 or {q52} = 2 or {q52} = 3 or {q52} = 4',
  //   q54: '{q52} = 1 or {q52} = 2 or {q52} = 3 or {q52} = 4',
  //   q57: '{q56} = 1 or {q56} = 2 or {q56} = 3 or {q56} = 4',
  //   q61: '{q60} = 1',
  //   q62: '{q60} = 1 and {q61} = 1',
  //   q66: '{q65} <> 1 and {q65} <> 2 and {q65} <> 3',
  //   q67: '{q65} <> 1 and {q65} <> 2 and {q65} <> 3',
  //   q68: '{q65} <> 1 and {q65} <> 2 and {q65} <> 3',
  //   q69: '{q65} <> 0 and {q65} <> 2 and {q65} <> 3',
  //   q70: '{q65} <> 0 and {q65} <> 2 and {q65} <> 3',
  //   q71: '{q65} <> 0 and {q65} <> 2 and {q65} <> 3',
  //   q75: "{q74} = 'other'",
  //   q80: `{q79} anyof ['none']`,
  //   q82: '{q81} = 1',
  //   q84: '{q83} = 1',
  //   q97: '{q96} = 7 or {q96} = 8 or {q96} = 9 or {q96} = 10 or {q96} = 11',
  //   q98: '{q96} = 0 or {q96} = 1 or {q96} = 2 or {q96} = 3 or {q96} = 4 or {q96} = 5 or {q96} = 6',
  //   q103: '{q102} = 0',
  //   q104: '{q102} = 1',
  //   q107: '{q96} = 7 or {q96} = 8 or {q96} = 9 or {q96} = 10 or {q96} = 11',
  //   q108: '{q96} = 0 or {q96} = 1 or {q96} = 2 or {q96} = 3 or {q96} = 4 or {q96} = 5 or {q96} = 6',
  //   q110: '{q109} <> 0',
  //   q111: '{q109} <> 0',
  //   q112: '( {q109} = 2 or {q109} = 3 or {q109} = 4 or {q109} = 5 or {q109} = 6 )',
  //   q113: '( {q109} = 2 or {q109} = 3 or {q109} = 4 or {q109} = 5 or {q109} = 6 )',
  //   q114: '( {q109} = 3 or {q109} = 4 or {q109} = 5 or {q109} = 6 )',
  //   q115: '( {q109} = 3 or {q109} = 4 or {q109} = 5 or {q109} = 6 )',
  //   q116: '( {q109} = 4 or {q109} = 5 or {q109} = 6 )',
  //   q117: '( {q109} = 4 or {q109} = 5 or {q109} = 6 )',
  //   q118: '( {q109} = 5 or {q109} = 6 )',
  //   q119: '( {q109} = 5 or {q109} = 6 )',
  //   q121: '{q120} <> 0',
  //   q135: '{q134} = 0',
  //   q145: '{q144} = 1',
  //   q147: '{q146} = 0',
  //   q156: '{q155} = 0',
  // }

  const visibleIfConditionsInit = {
    q15: '{q14} = 1 ',
    q16: '{q14} = 2',
    q17: '{q14} = 2',

    q19: '{q18} = 1',
    q20: '{q18} = 2',
    q21: '{q18} = 2',
    q22: '{q18} = 2',

    q24: '{q23} = 1',
    q25: '{q23} = 2',
    q26: '{q23} = 2',
  }
  // const visibleIfConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  // 非必填(從 0 計算)
  // const notRequired = [100]
  const notRequired = null

  const mappedRateChoice = null
  // const pageBreakQuestions = ['q2', 'q11', 'q15']
  const pageBreakQuestions = null

  // const triggersConditionsInit = {
  //   type: 'complete',
  //   expression: `{q3} = 0`,
  // }
  const triggersConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
  })

  const newSurvey = new Model(convertedSurvey)
  // useEffect(() => {
  //   console.log('convertedSurvey', convertedSurvey)
  // }, [convertedSurvey])

  function helpFunction(survey, options) {
    // 參考 P231113152849 或 P231101165555
    // if (survey.getValue('q3') === 0) {
    //   // alert('這個選項已經額滿')
    //   survey.completedHtml = `<h3>與您相同條件的作答數據已收集完畢，非常感謝您的積極參與！</h3><h4>如有填卷相關問題請洽：</h4> <a href='https://lin.ee/HWETcqy'>https://lin.ee/HWETcqy</a><h4 style='margin-top:50px'>填寫其他問卷：</h4> <a href=${window.location.origin}>${window.location.origin}</a>`
    // }
  }

  const canShowPrevButtonPages = null
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})

  useSubmitAnswers({
    survey: newSurvey,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
  })

  return (
    <>
      {convertedSurvey ? (
        <Survey model={newSurvey} />
      ) : myAgreeJson ? (
        <Survey model={agreeSurvey} />
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
